(function () {
    'use strict';

    angular
        .module('app')
        .controller('GamesListController', GamesListController);

    GamesListController.$inject = ['API', 'alert', 'debug',];

    function GamesListController(API, alert, debug) {
        var vm = this;
        vm.searchTerm = '';
        vm.page = 1;
        vm.perPage = 20;
        vm.search = search;
        vm.clearSearch = clearSearch;
        vm.listMeta = {};
        vm.loadingState = {
            gameIsLoading: false
        };
        vm.openRemoveModal = openRemoveModal;
        vm.loadPage = loadPage;


        activate();

        function activate() {
            loadGames();
        }

        function openRemoveModal() {
            alert.confirm('remove-something');
        }

        function clearSearch() {
            vm.searchTerm = '';
            vm.page = 1;
            loadGames();
        }

        function search() {
            vm.page = 1;
            loadGames();
        }

        function loadPage(newPageNumber) {
            vm.page = newPageNumber;
            loadGames();
        }

        function loadGames() {
            var promise = null;
            if (vm.searchTerm && vm.searchTerm.length > 2) {
                promise = API.Game.search({
                    'q': vm.searchTerm,
                    'page': vm.page,
                    'per-page': vm.perPage,
                }).$promise;
            } else if (vm.searchTerm.length === 0) {
                promise = API.Game.get({
                    'page': vm.page,
                    'per-page': vm.perPage,
                }).$promise;
            }

            if (promise) {
                vm.loadingState.gameIsLoading = true;
                promise.then(function (response) {
                    vm.games = response.items;
                    vm.listMeta = response._meta;
                    vm.loadingState.gameIsLoading = false;
                }, function (response) {
                    debug.log(response);
                });
            }
        }
    }
})();